<div>
  <div class="wrapper">
    @if (shouldShowMainLayout()) {
    <app-sidebar #sidebarComponent class="animated fadeIn bg-maindark"></app-sidebar>
    }
    <div id="content">
      <div class="container-flex">
        <router-outlet></router-outlet>
      </div>
      @if (shouldShowMainLayout()) {
      <app-admin-bar #adminbarComponent></app-admin-bar>
      }
    </div>
  </div>
</div>
